import * as React from 'react'

const createContext = <T>() => {
  const context = React.createContext<T | null>(null)
  const useContext = () => {
    const value = React.useContext(context)

    if (!value) {
      throw new Error('Context used without an initialized provider')
    }

    return value
  }

  return {
    context,
    hook: useContext,
  }
}

export default createContext
